import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { IAttribute, IModel } from '../../base/annotation';
import { Metamodel } from '../../base/model';
import { HdfsLinkedService } from '../../linkedservice/hdfs.linkedservice';
import { FilePath } from '../file-path';
import { ILocationPath, Location } from './location';
import { shellStringResources } from '../../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'HdfsLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(HdfsLinkedService)
    }
})
export class HdfsLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', HdfsLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', HdfsLocation.FILE_NAME, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: HdfsLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: HdfsLocation.FILE_NAME.templateValue(this) || this.fileName
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && HdfsLocation.FILE_NAME.templateValue(this) ? false : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(HdfsLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(HdfsLocation.FILE_NAME.templateValue(this));
    }
}
